import React from 'react';
import PropTypes from 'prop-types';

function AlertSystemCommentBody(props) {
  const {
    title,
    triggered,
    cleared,
    acknowledge,
    duration,
    lastReading,
  } = props;
  return (
    <>
      {title}
      <br />
      {triggered && (
        <>
          {triggered}
          <br />
        </>
      )}

      {cleared && (
        <>
          {cleared}
          <br />
        </>
      )}

      {acknowledge && (
        <>
          {acknowledge}
          <br />
        </>
      )}

      {duration && (
        <>
          {duration}
          <br />
        </>
      )}

      {lastReading && (
        lastReading
      )}

    </>
  );
}

AlertSystemCommentBody.defaultProps = {
  triggered: null,
  cleared: null,
  acknowledge: null,
  duration: null,
  lastReading: null,
};

AlertSystemCommentBody.propTypes = {
  title: PropTypes.string.isRequired,
  triggered: PropTypes.string,
  cleared: PropTypes.string,
  acknowledge: PropTypes.string,
  duration: PropTypes.string,
  lastReading: PropTypes.string,
};

export default AlertSystemCommentBody;
